import GenericAjaxService from './GenericAjaxService';
import {privateAPI, publicAPI} from './api';

export default class PasswordService extends GenericAjaxService {

  static sendEmail(data, opts) {
    return super.postAPI(publicAPI, `passwordreset/requestpasswordresetcode`, data, opts);
  }

  static resetPassword(username, resetCode, resetToken, newPassword, opts){
    const data = {username: username, resetCode: resetCode, resetToken: resetToken, newPassword: newPassword};
    return super.postAPI(publicAPI, `passwordreset/resetpassword`, data, opts);
  }

  static changePassword(oldPassword, newPassword){
    return super.postAPI(privateAPI, `changePassword`, {oldPassword: oldPassword, newPassword: newPassword});
  }
}